import React, { useMemo } from 'react';
import { FaMicroscope, FaAtom, FaRocket, FaGlobe, FaDna, FaBiohazard, FaBriefcaseMedical, FaVial, FaStethoscope } from 'react-icons/fa';

const icons = [FaMicroscope, FaAtom, FaRocket, FaGlobe, FaDna, FaBiohazard, FaBriefcaseMedical, FaVial, FaStethoscope];

const ScienceBackground = () => {
  const particles = useMemo(() => {
    return Array.from({ length: 40 }).map((_, i) => {
      // Create variation in size to establish depth of field
      const sizeRandom = Math.random();
      const size = sizeRandom * 70 + 20; // 20px to 90px
      
      // Determine layers for parallax and depth effects
      const isForeground = size > 65;
      const isBackground = size < 40;
      
      // Farther away = slower, blurrier, and less opaque
      const blur = isBackground ? 'blur(4px)' : isForeground ? 'blur(0px)' : 'blur(1.5px)';
      const opacity = isBackground ? 0.03 : isForeground ? 0.12 : 0.08;
      const duration = isBackground ? (Math.random() * 40 + 50) : isForeground ? (Math.random() * 20 + 25) : (Math.random() * 30 + 35);
      
      return {
        id: i,
        Icon: icons[i % icons.length],
        size,
        left: Math.random() * 100, // 0 to 100vw
        duration, 
        delay: Math.random() * -100, // Start evenly dispersed
        opacity,
        blur,
        swayDuration: Math.random() * 6 + 4, // 4s to 10s sway
        swayDelay: Math.random() * -10,
        // Gradient color variety
        colorClass: ['text-orange-500', 'text-amber-500', 'text-red-500', 'text-rose-500'][Math.floor(Math.random() * 4)],
      };
    });
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      {/* Modern Mesh Gradient Orbs Background */}
      <div className="absolute top-[-20%] left-[-10%] w-[40rem] h-[40rem] bg-gradient-to-br from-orange-400/10 to-amber-300/10 rounded-full blur-[120px] animate-pulse-glow" style={{ animationDuration: '10s' }}></div>
      <div className="absolute top-[30%] right-[-15%] w-[45rem] h-[45rem] bg-gradient-to-tr from-rose-500/10 to-orange-500/5 rounded-full blur-[140px] animate-pulse-glow" style={{ animationDuration: '14s', animationDelay: '3s' }}></div>
      <div className="absolute bottom-[-15%] left-[20%] w-[35rem] h-[35rem] bg-gradient-to-r from-red-500/5 to-amber-500/10 rounded-full blur-[100px] animate-pulse-glow" style={{ animationDuration: '12s', animationDelay: '7s' }}></div>

      {/* Floating Science Icons */}
      <div className="absolute w-full h-full">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className={`absolute flex items-center justify-center ${particle.colorClass} drop-shadow-2xl transition-transform`}
            style={{
              left: `${particle.left}%`,
              bottom: '-20%', 
              width: particle.size,
              height: particle.size,
              opacity: particle.opacity,
              filter: particle.blur,
              animation: `floatUp ${particle.duration}s linear infinite`,
              animationDelay: `${particle.delay}s`,
            }}
          >
            {/* Inner div for horizontal sway animation independent of vertical floating */}
            <div 
              className="w-full h-full flex items-center justify-center"
              style={{
                animation: `sway ${particle.swayDuration}s ease-in-out infinite alternate`,
                animationDelay: `${particle.swayDelay}s`,
              }}
            >
              <particle.Icon 
                size={particle.size} 
                className="animate-spin-slow drop-shadow-xl" 
                style={{ animationDuration: `${particle.duration * 0.7}s` }} 
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScienceBackground;
